import { axiosInstance as request } from '@api/rest.service'
import { AxiosPromise } from 'axios'

const api = '/ip-addresses'

/**
 * @typedef IpAddressResponse
 * @property {number} id
 * @property {string} ip_address
 * @property {'IPv4' | 'IPv6'} ip_range
 * @property {string} location
 * @property {string} description
 * @property {{ id: number, name: string }} provider
 * @property {boolean} should_be_dispatched
 */

/**
 * @typedef {Omit<IpAddressResponse, 'id' | 'provider'> & { provider_id: number }} IpAddressPayload
 */

/**
 * @description GET /ip-addresses
 * @returns {AxiosPromise<{result: IpAddress[]}>}
 */
export const IP_ADDRESSES = () => request.get(api)

/**
 * @description GET /ip-addresses/provider/{param}
 * @param {number} providerId
 * @returns {AxiosPromise<{result: IpAddress[]}>}
 */
export const IP_ADDRESSES_FOR_PROVIDER = providerId => request.get(`${api}/provider/${providerId}`)

/**
 * @description GET /ip-addresses/{param}
 * @param {number} id
 * @returns {AxiosPromise<{result: IpAddress}>}
 */
export const IP_ADDRESSES_GET_SINGLE = id => request.get(`${api}/${id}`)

/**
 * @description POST /ip-addresses
 * @param {IpAddressPayload} payload
 * @returns {AxiosPromise<{result: IpAddress}>}
 */
export const IP_ADDRESSES_CREATE = payload => request.post(api, payload)

/**
 * @description PUT /ip-addresses/{param}
 * @param {IpAddressPayload} payload
 * @param {number} id
 * @returns {AxiosPromise<{result: IpAddress}>}
 */
export const IP_ADDRESSES_UPDATE = (payload, id) => request.put(`${api}/${id}`, payload)

/**
 * @param {number} id
 * @returns {AxiosPromise<any>}
 */
export const IP_ADDRESSES_DELETE = id => request.delete(`${api}/${id}`)
